// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.categorybar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0.5rem 0;
  background: var(--ion-color-casino);
}

.safe-area-left {
  padding-left: env(safe-area-inset-left);
}

.categorybar-search {
  margin: 0 1rem;
  background-color: var(--ion-color-light);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
}
.categorybar-search ion-icon {
  font-size: 1.25rem;
}

@media screen and (orientation: landscape) {
  .ios-app-notch-search {
    margin-left: max(env(safe-area-inset-left), 1rem);
  }
}

.categorybar-close {
  margin: 0 1rem;
  background-color: transparent;
  border: 2.6px solid var(--ion-color-light);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  flex-shrink: 0;
}
.categorybar-close ion-icon {
  font-size: 1.6rem;
}

@media screen and (orientation: landscape) {
  .ios-app-notch-close {
    margin-left: env(safe-area-inset-left);
  }
}

.categorybar__category {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  overflow-x: scroll;
  overflow-y: hidden;
  gap: 0.5rem;
}
.categorybar__category .category-icon {
  filter: brightness(0) saturate(100%) invert(93%) sepia(1%) saturate(7107%) hue-rotate(183deg) brightness(88%) contrast(86%);
}
.categorybar__category .active .category-icon {
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(201deg) brightness(107%) contrast(101%);
}

.category-icon {
  margin-right: 0.5rem;
  font-size: 1.5rem;
}

ion-button[name*=category] {
  min-width: 5rem;
  height: 2.25rem;
  min-height: 2.25rem;
  --border-radius: 1.25rem;
  font-size: 1rem;
  font-weight: 500;
  text-transform: titlecase;
  --color: var(--catbar-btn-color);
  --background: transparent;
  --background-hover: transparent;
  --border: var(--catbar-btn-color);
  --border-style: solid;
  --border-width: 2px;
  margin: 0;
  flex-shrink: 0;
  --background-activated: transparent;
  --background-focused: transparent;
  --background-hover: transparent;
}
ion-button[name*=category].active {
  cursor: default !important;
  pointer-events: none;
  --background: var(--ion-color-secondary);
  --color: var(--ion-color-light);
  --border-color: var(--ion-color-secondary);
  --background-activated: var(--ion-color-secondary);
  --background-focused: var(--ion-color-secondary);
  --background-hover: var(--ion-color-secondary);
}
ion-button[name*=category].active .category-icon {
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(201deg) brightness(107%) contrast(101%);
}
ion-button[name*=category]:last-of-type {
  margin-right: 1rem;
}

.categorybar__scrollcontainer {
  position: relative;
  flex: 1;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding-left: 1px;
}
.categorybar__scrollcontainer .categorybar__scrollbutton {
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 2.5rem;
  height: 100%;
  z-index: 1;
}
.categorybar__scrollcontainer .categorybar__scrollbutton::after {
  content: "";
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  border: 3px solid var(--ion-color-casino);
  position: absolute;
  background-color: var(--drag-scroll-btn-color);
  box-sizing: border-box;
}
.categorybar__scrollcontainer .categorybar__scrollbutton::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
}
.categorybar__scrollcontainer .categorybar__scrollbutton ion-icon {
  font-size: 1rem;
  padding: 6px;
  z-index: 1;
}
.categorybar__scrollcontainer .categorybar__scrollbutton.categorybar__scrollbutton--right {
  right: 0;
  left: unset;
}
.categorybar__scrollcontainer .categorybar__scrollbutton.categorybar__scrollbutton--right::before {
  background: var(--ion-color-casino);
  background: linear-gradient(270deg, var(--ion-color-casino) 0%, var(--ion-color-casino) 50%, rgba(245, 245, 250, 0) 100%);
}
.categorybar__scrollcontainer .categorybar__scrollbutton.categorybar__scrollbutton--left {
  left: 0;
  right: unset;
}
.categorybar__scrollcontainer .categorybar__scrollbutton.categorybar__scrollbutton--left::before {
  background: var(--ion-color-casino);
  background: linear-gradient(90deg, var(--ion-color-casino) 0%, var(--ion-color-casino) 50%, rgba(245, 245, 250, 0) 100%);
}

@media screen and (max-width: 576px) {
  .categorybar {
    padding: 0.75rem 0;
  }
  .categorybar__scrollcontainer .categorybar__scrollbutton {
    display: none;
  }
  .categorybar-search {
    margin: 0 0.75rem;
  }
  ion-button:last-of-type {
    margin-right: 0.75rem;
  }
}
.zoom-buttons-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  flex-grow: 1;
  padding: 0 1rem;
}
.zoom-buttons-container .zoom-button {
  width: 32px;
  height: 32px;
}
.zoom-buttons-container ion-button {
  opacity: 1;
}
.zoom-buttons-container ion-button[disabled] {
  opacity: 0.3;
  filter: grayscale(100%);
}`, "",{"version":3,"sources":["webpack://./src/app/components/catbar/catbar.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,mCAAA;AACJ;;AAEA;EACI,uCAAA;AACJ;;AAEA;EACI,cAAA;EACA,wCAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AACJ;AACI;EACI,kBAAA;AACR;;AAII;EADJ;IAEQ,iDAAA;EAAN;AACF;;AAGA;EACI,cAAA;EACA,6BAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAAJ;AAEI;EACI,iBAAA;AAAR;;AAKI;EADJ;IAEQ,sCAAA;EADN;AACF;;AAIA;EACI,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AADJ;AAGI;EACI,2HAAA;AADR;AAKQ;EACI,2HAAA;AAHZ;;AAQA;EACI,oBAAA;EACA,iBAAA;AALJ;;AAQA;EACI,eAAA;EACA,eAAA;EACA,mBAAA;EACA,wBAAA;EAEA,eAAA;EACA,gBAAA;EACA,yBAAA;EAEA,gCAAA;EACA,yBAAA;EACA,+BAAA;EACA,iCAAA;EACA,qBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EAEA,mCAAA;EACA,iCAAA;EACA,+BAAA;AARJ;AAUI;EACI,0BAAA;EACA,oBAAA;EACA,wCAAA;EACA,+BAAA;EACA,0CAAA;EACA,kDAAA;EACA,gDAAA;EACA,8CAAA;AARR;AAUQ;EACI,2HAAA;AARZ;AAYI;EACI,kBAAA;AAVR;;AAcA;EACI,kBAAA;EACA,OAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAXJ;AAaI;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;AAXR;AAaQ;EACI,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,yCAAA;EACA,kBAAA;EACA,8CAAA;EACA,sBAAA;AAXZ;AAcQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAZZ;AAeQ;EACI,eAAA;EACA,YAAA;EACA,UAAA;AAbZ;AAgBQ;EACI,QAAA;EACA,WAAA;AAdZ;AAgBY;EACI,mCAAA;EACA,yHAAA;AAdhB;AAkBQ;EACI,OAAA;EACA,YAAA;AAhBZ;AAkBY;EACI,mCAAA;EACA,wHAAA;AAhBhB;;AAsBA;EACI;IACI,kBAAA;EAnBN;EAuBM;IACI,aAAA;EArBV;EAyBE;IACI,iBAAA;EAvBN;EA2BM;IACI,qBAAA;EAzBV;AACF;AA6BA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;AA3BJ;AA6BI;EACI,WAAA;EACA,YAAA;AA3BR;AA8BI;EACI,UAAA;AA5BR;AA+BI;EACI,YAAA;EACA,uBAAA;AA7BR","sourcesContent":[".categorybar {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    padding: .5rem 0;\n    background: var(--ion-color-casino);\n}\n\n.safe-area-left {\n    padding-left: env(safe-area-inset-left);\n}\n\n.categorybar-search {\n    margin: 0 1rem;\n    background-color: var(--ion-color-light);\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 2.25rem;\n    height: 2.25rem;\n\n    ion-icon {\n        font-size: 1.25rem;\n    }\n}\n\n.ios-app-notch-search {\n    @media screen and (orientation: landscape) {\n        margin-left: max(env(safe-area-inset-left), 1rem);\n    }\n}\n\n.categorybar-close {\n    margin: 0 1rem;\n    background-color: transparent;\n    border: 2.6px solid var(--ion-color-light);\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 2.25rem;\n    height: 2.25rem;\n    flex-shrink: 0;\n\n    ion-icon {\n        font-size: 1.6rem;\n    }\n}\n\n.ios-app-notch-close {\n    @media screen and (orientation: landscape) {\n        margin-left: env(safe-area-inset-left);\n    }\n}\n\n.categorybar__category {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex: 1;\n    overflow-x: scroll;\n    overflow-y: hidden;\n    gap: 0.5rem;\n\n    .category-icon {\n        filter: brightness(0) saturate(100%) invert(93%) sepia(1%) saturate(7107%) hue-rotate(183deg) brightness(88%) contrast(86%);\n    }\n\n    .active {\n        .category-icon {\n            filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(201deg) brightness(107%) contrast(101%);\n        }\n    }\n}\n\n.category-icon {\n    margin-right: 0.5rem;\n    font-size: 1.5rem;\n}\n\nion-button[name*='category'] {\n    min-width: 5rem;\n    height: 2.25rem;\n    min-height: 2.25rem;\n    --border-radius: 1.25rem;\n\n    font-size: 1rem;\n    font-weight: 500;\n    text-transform: titlecase;\n\n    --color: var(--catbar-btn-color);\n    --background: transparent;\n    --background-hover: transparent;\n    --border: var(--catbar-btn-color);\n    --border-style: solid;\n    --border-width: 2px;\n    margin: 0;\n    flex-shrink: 0;\n\n    --background-activated: transparent;\n    --background-focused: transparent;\n    --background-hover: transparent;\n\n    &.active {\n        cursor: default !important;\n        pointer-events: none;\n        --background: var(--ion-color-secondary);\n        --color: var(--ion-color-light);\n        --border-color: var(--ion-color-secondary);\n        --background-activated: var(--ion-color-secondary);\n        --background-focused: var(--ion-color-secondary);\n        --background-hover: var(--ion-color-secondary);\n\n        .category-icon {\n            filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(201deg) brightness(107%) contrast(101%);\n        }\n    }\n\n    &:last-of-type {\n        margin-right: 1rem;\n    }\n}\n\n.categorybar__scrollcontainer {\n    position: relative;\n    flex: 1;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    padding-left: 1px;\n\n    .categorybar__scrollbutton {\n        z-index: 1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        margin: auto;\n        width: 2.5rem;\n        height: 100%;\n        z-index: 1;\n\n        &::after {\n            content: '';\n            width: 2.5rem;\n            height: 2.5rem;\n            border-radius: 50%;\n            border: 3px solid var(--ion-color-casino);\n            position: absolute;\n            background-color: var(--drag-scroll-btn-color);\n            box-sizing: border-box;\n        }\n\n        &::before {\n            content: '';\n            width: 100%;\n            height: 100%;\n            position: absolute;\n        }\n\n        ion-icon {\n            font-size: 1rem;\n            padding: 6px;\n            z-index: 1;\n        }\n\n        &.categorybar__scrollbutton--right {\n            right: 0;\n            left: unset;\n\n            &::before {\n                background: var(--ion-color-casino);\n                background: linear-gradient(270deg, var(--ion-color-casino) 0%, var(--ion-color-casino) 50%, rgba(245, 245, 250, 0) 100%);\n            }\n        }\n\n        &.categorybar__scrollbutton--left {\n            left: 0;\n            right: unset;\n\n            &::before {\n                background: var(--ion-color-casino);\n                background: linear-gradient(90deg, var(--ion-color-casino) 0%, var(--ion-color-casino) 50%, rgba(245, 245, 250, 0) 100%);\n            }\n        }\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .categorybar {\n        padding: 0.75rem 0;\n    }\n\n    .categorybar__scrollcontainer {\n        .categorybar__scrollbutton {\n            display: none;\n        }\n    }\n\n    .categorybar-search {\n        margin: 0 0.75rem;\n    }\n\n    ion-button {\n        &:last-of-type {\n            margin-right: 0.75rem;\n        }\n    }\n}\n\n.zoom-buttons-container {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 1rem;\n    flex-grow: 1;\n    padding: 0 1rem;\n\n    .zoom-button {\n        width: 32px;\n        height: 32px;\n    }\n\n    ion-button {\n        opacity: 1;\n    }\n\n    ion-button[disabled] {\n        opacity: 0.3;\n        filter: grayscale(100%);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
